import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Typography,
  Grid,
  CardContent,
} from '@material-ui/core';
import { RowsProp, DataGrid, RowParams } from '@material-ui/data-grid';

import { MessageRepository } from 'domain/repository';
import Message from 'domain/model/message';
import { MessageFieldDefinition } from 'domain/model/field_difinition';
import { useRepository } from 'components/lib/Repository';
import { CustomPagination } from 'components/Pagination';
import { useFilter } from "hooks/useFilter";
import { FilterForm } from 'components/Filter';
import { CustomModal } from 'components/Modal';
import { useIndex } from 'hooks/useIndex';

export const MessageIndex = () => {
  const messageRepository = useRepository(MessageRepository);
  const [rows, setRows] = useState<RowsProp>([]);
  const {
    page,
    totalPage,
    sort,
    sortingMode,
    handlePageChange,
    handleSortChange,
    changeTotal,
  } = useIndex();
  const { filters, handleSetFilters, } = useFilter();
  const [opened, setOpened] = useState<boolean>(false);
  const [row, setRow] = useState<Message | null>(null);

  const handleClose = () =>   {
    setOpened(false);
  }

  useEffect(() => {
    messageRepository.fetchIndex({page, sort, filters: filters}).then(res => {
      const { total } = res;
      changeTotal(total);
      setRows(res.messages);
    });
  }, [page, sort, filters]);

  const handleClickRow = (params: RowParams) => {
    setRow(params.row as Message)
    setOpened(true)
  }

   return (
    <>
      <Toolbar>メッセージ一覧</Toolbar>
      <FilterForm
        handleFilter={handleSetFilters}
        fieldDefinition={MessageFieldDefinition}
      />
      <div style={{ width: '100%', minHeight: 600 }}>
        <DataGrid
          rows={rows}
          columns={[
            {
              field: 'id',
              flex: 1,
            },
            {
              field: 'senderType',
              headerName:"送信者",
              flex: 1,
              sortable: false,
            },
            {
              field: 'userId',
              headerName:"ユーザーID",
              flex: 1,
            },
            {
              field: 'userName',
              headerName:"ユーザー名",
              width: 200,
              flex: 1,
            },
            {
              field: 'companyId',
              headerName:"企業ID",
              flex: 1,
            },
            {
              field: 'companyName',
              headerName:"企業名",
              width: 200,
              flex: 1,
            },
            {
              field: 'createdAt',
              headerName:"送信日",
              width: 200,
              sortable: false,
            },
          ]}
          pagination
          rowCount={totalPage}
          paginationMode="server"
          sortingMode={sortingMode}
          onPageChange={handlePageChange}
          onSortModelChange={handleSortChange}
          components={{pagination: CustomPagination}}
          onRowClick={handleClickRow}
          rowsPerPageOptions={[100]}
          disableColumnResize={true}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          loading={false}
        />
      </div>
      <CustomModal
        opened={opened}
        handleClose={handleClose}
      >
        <CardContent>
        <Grid container spacing={3} style={{padding: '20px'}}>
          <Grid item xs={2}>
            <Typography>content</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography style={{ overflowWrap: 'break-word', maxWidth: '750px' }}>{row?.content}</Typography>
          </Grid>
        </Grid>
        </CardContent>
      </CustomModal>
    </>
  );
};
